import classNames from 'clsx';
import React from 'react';

import type { Category } from '@swf/core/types/StarsCoinReward';
import type WithChildren from '@swf/core/types/WithChildren';

import Title from '../Title/Title';
import type WithClose from '../WithClose';

import styles from './Container.scss';

interface Props extends WithChildren, WithClose {
  category: Category;
  right?: React.ReactNode;
  className?: string;
}

const Container: React.FC<Props> = ({ category, right, children, className, close }) => (
  <div className={classNames(styles.container, styles[category], className)}>
    <div className={styles.headerWrapper}>
      <header className={classNames(styles.header, styles[category])}>
        <Title category={category} />
      </header>
      <div className={styles.close}>
        {right || <div />} {close}
      </div>
    </div>
    <div className={styles.children}>{children}</div>
  </div>
);

export default Container;
